import prop from "ramda/es/prop";
import map from "ramda/es/map";
import { selectCurrentUserNivel } from "./auth";

export const selectAllViajes = state => {
  const { viajes } = state.firebase;

  const byId = prop(viajes);

  if (!viajes || !viajes.allIds) return [];
  const allViajes = viajes.allIds.map(viajeId => {
    const viaje = viajes.byId[viajeId];
    return viaje;
  });
  return allViajes;
};

export const selectCurrentViaje = (state, viajeId) => {
  const currentUserNivel = selectCurrentUserNivel(state);
  const allViajes = selectAllViajes(state);
  const viajeIndividual =
    allViajes.filter(viaje => viaje.nivel == currentUserNivel)[0] || {};

  if (viajeId) {
    return allViajes.filter(viaje => viaje.key === viajeId);
  }
  return viajeIndividual;
};
